import { render, staticRenderFns } from "./AdminFormServicePrices.vue?vue&type=template&id=2846ca68&"
import script from "./AdminFormServicePrices.vue?vue&type=script&lang=ts&"
export * from "./AdminFormServicePrices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports